import React from 'react';
export function Qualification() {
  return <section className="py-[80px] px-6 md:py-[120px] md:px-[72px]" data-id="element-113">
      <div className="max-w-[1200px] mx-auto" data-id="element-114">
        <div className="inline-flex items-center gap-2.5 text-[10px] tracking-[3px] uppercase text-gold mb-5 font-medium" data-id="element-115">
          <span className="w-6 h-px bg-gold" data-id="element-116"></span>
          ¿Es para ti?
        </div>

        <h2 className="font-serif text-[clamp(38px,4vw,62px)] font-light leading-[1.08] tracking-tight mb-5 text-cream" data-id="element-117">
          Lee esto antes de
          <br data-id="element-118" />
          <em className="italic text-gold-bright" data-id="element-119">aplicar.</em>
        </h2>

        <p className="text-[17px] text-muted max-w-[520px] leading-relaxed" data-id="element-120">
          Solo aceptamos 5 negocios a la vez. Sé honesto contigo mismo — esto
          determina si podemos ayudarte o no.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-6 mt-14" data-id="element-121">
          {/* YES Column */}
          <div data-id="element-122">
            <div className="flex items-center gap-3 mb-5 pb-5 border-b border-[#1a1a1a]" data-id="element-123">
              <span className="text-2xl" data-id="element-124">✅</span>
              <div className="font-serif text-[26px] font-light tracking-tight text-cream" data-id="element-125">
                Esto es para ti{' '}
                <em className="italic text-gold-bright" data-id="element-126">si...</em>
              </div>
            </div>
            <div className="flex flex-col gap-3" data-id="element-127">
              <div className="flex items-start gap-3.5 p-5 bg-[rgba(74,158,106,0.05)] border border-[rgba(74,158,106,0.18)]" data-id="element-128">
                <span className="text-lg shrink-0 mt-px" data-id="element-129">✅</span>
                <div data-id="element-130">
                  <div className="text-[15px] font-medium text-cream mb-1" data-id="element-131">
                    Ya tienes un negocio activo de reparación de crédito
                  </div>
                  <div className="text-[13px] text-muted leading-relaxed" data-id="element-132">
                    Estás inscribiendo clientes hoy. Solo necesitas más, de
                    forma consistente y predecible.
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3.5 p-5 bg-[rgba(74,158,106,0.05)] border border-[rgba(74,158,106,0.18)]" data-id="element-133">
                <span className="text-lg shrink-0 mt-px" data-id="element-134">✅</span>
                <div data-id="element-135">
                  <div className="text-[15px] font-medium text-cream mb-1" data-id="element-136">
                    Puedes invertir $2500 o mas en anuncios al mes
                  </div>
                  <div className="text-[13px] text-muted leading-relaxed" data-id="element-137">
                    Total:{' '}
                    <strong className="text-gold font-bold" data-id="element-138">$2,500/mes</strong>{' '}
                    — el mínimo para generar leads de forma consistente.
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3.5 p-5 bg-[rgba(74,158,106,0.05)] border border-[rgba(74,158,106,0.18)]" data-id="element-139">
                <span className="text-lg shrink-0 mt-px" data-id="element-140">✅</span>
                <div data-id="element-141">
                  <div className="text-[15px] font-medium text-cream mb-1" data-id="element-142">
                    Tienes (o estás construyendo) un proceso para cerrar ventas
                  </div>
                  <div className="text-[13px] text-muted leading-relaxed" data-id="element-143">
                    Nosotros traemos los leads calificados. Tú necesitas quien
                    los cierre.
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3.5 p-5 bg-[rgba(74,158,106,0.05)] border border-[rgba(74,158,106,0.18)]" data-id="element-144">
                <span className="text-lg shrink-0 mt-px" data-id="element-145">✅</span>
                <div data-id="element-146">
                  <div className="text-[15px] font-medium text-cream mb-1" data-id="element-147">
                    Buscas escalar en serio, no solo "probar"
                  </div>
                  <div className="text-[13px] text-muted leading-relaxed" data-id="element-148">
                    Compromiso mínimo de 3 meses para construir y optimizar el
                    sistema.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* NO Column */}
          <div data-id="element-149">
            <div className="flex items-center gap-3 mb-5 pb-5 border-b border-[#1a1a1a]" data-id="element-150">
              <span className="text-2xl" data-id="element-151">❌</span>
              <div className="font-serif text-[26px] font-light tracking-tight text-cream" data-id="element-152">
                Esto <em className="italic text-[#b85a5a]" data-id="element-153">NO</em> es para ti
                si...
              </div>
            </div>
            <div className="flex flex-col gap-3" data-id="element-154">
              <div className="flex items-start gap-3.5 p-5 bg-[rgba(158,74,74,0.05)] border border-[rgba(158,74,74,0.18)]" data-id="element-155">
                <span className="text-lg shrink-0 mt-px" data-id="element-156">❌</span>
                <div data-id="element-157">
                  <div className="text-[15px] font-medium text-cream mb-1" data-id="element-158">
                    Apenas estás empezando y no tienes clientes aún
                  </div>
                  <div className="text-[13px] text-muted leading-relaxed" data-id="element-159">
                    Sin servicio comprobado, el volumen de leads no sirve de
                    nada.
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3.5 p-5 bg-[rgba(158,74,74,0.05)] border border-[rgba(158,74,74,0.18)]" data-id="element-160">
                <span className="text-lg shrink-0 mt-px" data-id="element-161">❌</span>
                <div data-id="element-162">
                  <div className="text-[15px] font-medium text-cream mb-1" data-id="element-163">
                    Tu presupuesto total es menos de $2,500/mes
                  </div>
                  <div className="text-[13px] text-muted leading-relaxed" data-id="element-164">
                    No podemos generar volumen ni optimizar correctamente por
                    debajo de ese mínimo.
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3.5 p-5 bg-[rgba(158,74,74,0.05)] border border-[rgba(158,74,74,0.18)]" data-id="element-165">
                <span className="text-lg shrink-0 mt-px" data-id="element-166">❌</span>
                <div data-id="element-167">
                  <div className="text-[15px] font-medium text-cream mb-1" data-id="element-168">
                    Quieres resultados en la primera semana
                  </div>
                  <div className="text-[13px] text-muted leading-relaxed" data-id="element-169">
                    Un sistema predecible toma 30–60 días de optimización. No
                    hay atajos.
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3.5 p-5 bg-[rgba(158,74,74,0.05)] border border-[rgba(158,74,74,0.18)]" data-id="element-170">
                <span className="text-lg shrink-0 mt-px" data-id="element-171">❌</span>
                <div data-id="element-172">
                  <div className="text-[15px] font-medium text-cream mb-1" data-id="element-173">
                    No quieres implementar un proceso de seguimiento
                  </div>
                  <div className="text-[13px] text-muted leading-relaxed" data-id="element-174">
                    Los leads sin seguimiento son dinero botado. CRM es
                    obligatorio.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Banner */}
        <div className="mt-12 p-9 md:py-9 md:px-12 bg-surface border border-subdued flex flex-col md:flex-row items-start md:items-center justify-between gap-6 md:gap-8 relative overflow-hidden" data-id="element-175">
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-176" />
          <div data-id="element-177">
            <div className="font-serif text-[26px] font-light mb-1.5 text-cream" data-id="element-178">
              ¿Cumples los requisitos?{' '}
              <em className="italic text-gold-bright" data-id="element-179">Aplica ahora.</em>
            </div>
            <div className="text-sm text-muted" data-id="element-180">
              Quedan{' '}
              <span className="text-gold font-medium" data-id="element-181">
                3 espacios disponibles
              </span>{' '}
              este mes.
            </div>
          </div>
          <a href="#apply" className="shrink-0 inline-flex items-center gap-2.5 bg-gold border border-gold text-ink text-[13px] font-semibold tracking-[1.2px] uppercase py-4 px-10 transition-all duration-250 hover:bg-gold-bright hover:-translate-y-[1px] hover:shadow-[0_16px_48px_rgba(184,151,58,0.20)]" data-id="element-182">
            Ver si Califico →
          </a>
        </div>

        {/* Caso Real - Dany Credit Stat Card */}
        <div className="mt-14 bg-surface border border-subdued p-0 relative overflow-hidden max-w-[800px] mx-auto" data-id="element-183">
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-184" />

          <div className="text-[10px] tracking-[2.5px] uppercase text-gold pt-6 px-7 font-medium flex items-center gap-2 mb-4" data-id="element-185">
            <span className="w-4 h-px bg-gold" data-id="element-186"></span>
            Caso Real — Dany Credit
          </div>

          <div className="grid grid-cols-2 gap-px bg-subdued mb-px" data-id="element-187">
            <div className="bg-mid p-7" data-id="element-188">
              <div className="text-[10px] tracking-[2px] uppercase text-muted mb-2.5" data-id="element-189">
                Facturación alcanzada
              </div>
              <div className="font-sans text-[64px] font-light leading-[0.9] tracking-tight text-cream" data-id="element-190">
                $1<em className="italic text-gold-bright" data-id="element-191">M</em>
              </div>
              <div className="text-xs text-muted mt-2.5" data-id="element-192">
                De 6 cifras al millón
              </div>
            </div>
            <div className="bg-mid p-7" data-id="element-193">
              <div className="text-[10px] tracking-[2px] uppercase text-muted mb-2.5" data-id="element-194">
                Leads por mes ahora
              </div>
              <div className="font-serif text-[64px] font-light leading-[0.9] tracking-tight text-cream" data-id="element-195">
                800<em className="italic text-gold-bright text-[40px]" data-id="element-196">+</em>
              </div>
              <div className="text-xs text-muted mt-2.5" data-id="element-197">
                Leads calificados/mes
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-px bg-subdued mb-px" data-id="element-198">
            <div className="bg-surface p-5 text-center" data-id="element-199">
              <span className="font-serif text-[26px] font-semibold text-gold-bright block mb-1" data-id="element-200">
                ↓60%
              </span>
              <span className="text-[11px] text-muted tracking-wide" data-id="element-201">
                Costo por lead
              </span>
            </div>
            <div className="bg-surface p-5 text-center" data-id="element-202">
              <span className="font-serif text-[26px] font-semibold text-gold-bright block mb-1" data-id="element-203">
                3×
              </span>
              <span className="text-[11px] text-muted tracking-wide" data-id="element-204">
                Volumen clientes
              </span>
            </div>
          </div>

          <div className="bg-surface p-6 md:px-7 md:py-6 flex items-center gap-4" data-id="element-205">
            <div className="w-11 h-11 rounded-full border border-gold-line bg-gold-pale flex items-center justify-center font-serif text-xl font-semibold text-gold-bright shrink-0" data-id="element-206">
              D
            </div>
            <div className="flex-1" data-id="element-207">
              <div className="text-[13px] italic text-[#a09880] leading-relaxed mb-1.5" data-id="element-208">
                "Llegamos al millón y no nos vamos a detener ahí."
              </div>
              <div className="text-xs font-medium text-cream" data-id="element-209">
                Dany Credit{' '}
                <span className="text-muted font-light" data-id="element-210">
                  · Agencia de Reparación de Crédito
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}